/**
 * Catechism data (Russian) — "Катехизис: Для сердца и ума!"
 * Source: https://usaregeneration.church/сatechesis-ru/
 *
 * Structure:
 *   3 parts, 52 Q&A flip-cards total
 *   Each card: question, Bible reference, Bible verse, answer, icon
 *
 * Image assets (original):
 *   Hero:    /wp-content/uploads/2025/10/fon-k-ua-1920x760-1.jpg
 *   Cards:   /wp-content/uploads/2025/10/e{NN}a.webp (front), e{NN}b.webp (back)
 */

const catechismDataRu = {
  title: 'Катехизис',
  subtitle: 'Для сердца и ума!',
  heroImage: 'fon-k-ua-1920x760-1.jpg',

  parts: [
    // ─────────────────────────────────────────────
    // PART 1 — Бог, творение, грехопадение и закон
    // ─────────────────────────────────────────────
    {
      id: 1,
      title: 'Бог, творение, грехопадение и закон.',
      color: '#F5A623', // orange
      icon: 'cross-heart',
      questions: [
        {
          id: 1,
          question: 'В чем наша единственная надежда в жизни и после смерти?',
          reference: 'Римлянам 14:7-8',
          verse:
            'Ибо никто из нас не живет для себя, и никто не умирает для себя; а живем ли — для Господа живем; умираем ли — для Господа умираем: и потому, живем ли или умираем, —всегда Господни.',
          answer:
            'В том, что мы принадлежим не самим себе, а полностью – духом, душой и телом – Богу и нашему Спасителю Иисусу Христу.',
        },
        {
          id: 2,
          question: 'Кто такой Бог?',
          reference: 'Псалтирь 85:8-10,15',
          verse:
            'Нет между богами, как Ты, Господи, и нет дел, как Твои. Все народы, Тобою сотворенные, приидут и поклонятся пред Тобою, Господи, и прославят имя Твое, ибо Ты велик и творишь чудеса, — Ты, Боже, един Ты. Но Ты, Господи, Боже щедрый и благосердый, долготерпеливый и многомилостивый и истинный,',
          answer:
            'Бог - создатель и центр жизни всего и каждого. Он вечный, бесконечный и неизменный в Его силе и совершенстве, божественности и славе, мудрости, справедливости и истинности. Ничто что происходит, не может произойти без Его участия и Его воли.',
        },
        {
          id: 3,
          question: 'Из скольких личностей состоит Бог?',
          reference: '2 Коринфянам 13:13',
          verse:
            'Благодать Господа нашего Иисуса Христа, и любовь Бога Отца, и общение Святого Духа со всеми вами. Аминь.',
          answer:
            'Единственный живой Бог – это три личности одного Бога: Отец, Сын и Святой Дух. Они едины, одинаковы по Своей природе и равны в Своей силе и славе.',
        },
        {
          id: 4,
          question: 'Как и зачем Бог сотворил нас?',
          reference: 'Бытие 1:27',
          verse:
            'И сотворил Бог человека по образу Своему, по образу Божию сотворил его; мужчину и женщину сотворил их.',
          answer:
            'Бог сотворил мужчин и женщин похожими на Себя так, чтобы мы могли знать Его, любить Его, жить с Ним и прославлять Его. Поэтому мы, сотворенные Богом, должны жить для Его славы.',
        },
        {
          id: 5,
          question: 'Что еще, кроме человека, сотворил Бог?',
          reference: 'Бытие 1:31',
          verse:
            'И увидел Бог все, что Он создал, и вот, хорошо весьма. И был вечер, и было утро: день шестой.',
          answer:
            'Бог сотворил абсолютно всё Своим могущественным Словом, и всё Его творение прекрасно. Всё расцветает под Его любящим руководством.',
        },
        {
          id: 6,
          question: 'Как мы можем прославить Бога?',
          reference: 'Второзаконие 11:1',
          verse:
            'Итак, люби Господа, Бога твоего, и соблюдай, что повелено Им соблюдать, и постановления Его, и законы Его, и заповеди Его во все дни.',
          answer:
            'Мы прославляем Бога тем, что наслаждаемся Им, любим Его, надеемся на Него, а также тем, что мы послушны Его воле, заповедям и закону.',
        },
        {
          id: 7,
          question: 'Чего требует закон Бога?',
          reference: 'Матфея 22:37-40',
          verse:
            'Иисус сказал ему: «возлюби Господа Бога твоего всем сердцем твоим и всею душою твоею и всем разумением твоим — сия есть первая и наибольшая заповедь; вторая же подобная ей: «возлюби ближнего твоего, как самого себя»; на сих двух заповедях утверждается весь закон и пророки.',
          answer:
            'Он требует личного, совершенного и постоянного послушания; чтобы мы любили Бога всем нашим сердцем, всей душой и всеми силами; чтобы мы любили тех, кто рядом, как мы любим самих себя. Мы никогда не должны делать то, что Бог запрещает, и мы всегда должны делать то, что Бог требует.',
        },
        {
          id: 8,
          question: 'В чем суть закона, который записан в «10 заповедей»?',
          reference: 'Исход 20:3',
          verse: 'Да не будет у тебя других богов пред лицом Моим.',
          answer:
            'Не должно быть у тебя других богов наряду со Мною. Не делай себе идолов из того, что вверху на небе, или того, что внизу на земле, или того, что в воде, ниже земли. Не поклоняйся им и не служи им. Не произноси попусту имя Господа, Бога твоего. Помни, что Суббота – священный день. Почитай отца и мать. Не убивай. Не прелюбодействуй. Не воруй. Не давай ложных показаний. Не желай чужого.',
        },
        {
          id: 9,
          question: 'Чего Бог требует в первой, второй и третьей заповедях?',
          reference: 'Второзаконие 6:13-14',
          verse:
            'Господа, Бога твоего, бойся, и Ему одному служи, и Его именем клянись. Не последуйте иным богам, богам тех народов, которые будут вокруг вас;',
          answer:
            'Во-первых, чтобы мы знали Бога и надеялись на Него как на единственно истинного и живого Бога. Во-вторых, чтобы мы избегали поклонения идолам и неправильного поклонения Богу. В-третьих, чтобы мы относились к имени Бога со страхом и трепетом, почитая также Его Слово и Его дела.',
        },
        {
          id: 10,
          question: 'Чего Бог требует в 4 и 5 заповедях?',
          reference: 'Исход 20:11-12',
          verse:
            'ибо в шесть дней создал Господь небо и землю, море и все, что в них, а в день седьмой почил; посему благословил Господь день субботний и освятил его. Почитай отца твоего и мать твою, чтобы продлились дни твои на земле, которую Господь, Бог твой, дает тебе.',
          answer:
            'Четвертая заповедь говорит о том, что мы имеем шесть дней для работы, а Седьмой день, мы должны проводить в общественном и личном прославлении Бога, в отдыхе от каждодневной работы, служа Богу и людям, и таким образом предвкушая вечный Седьмой день. Пятая заповедь требует, чтобы мы любили и уважали наших родителей, покоряясь их порядкам и воспитанию.',
        },
        {
          id: 11,
          question: 'Чего Бог требует в 6, 7 и 8 заповедях?',
          reference: 'Римлянам 13:9',
          verse:
            'Ибо заповеди: «не прелюбодействуй», «не убивай», «не кради», «не лжесвидетельствуй», «не пожелай чужого» и все другие заключаются в сем слове: «люби ближнего твоего, как самого себя».',
          answer:
            'В шестой заповеди говорится о том, чтобы мы не обижали, не ненавидели, не ссорились с нашими ближними, но чтобы были терпеливыми и дружелюбными, относясь с любовью даже к нашим врагам. Седьмая заповедь требует, чтобы мы воздерживались от сексуальной распущенности и жили чисто и верно, как в браке, так и в одиночестве, избегая нечистых поступков, взглядов, разговоров, мыслей, желаний, и даже всего, что может к ним привести. Восьмая заповедь требует, чтобы мы не брали без разрешения то, что принадлежит кому-то другому, и чтобы мы делились тем, что у нас есть, с нуждающимися.',
        },
        {
          id: 12,
          question: 'Чего Бог требует в девятой и десятой заповедях?',
          reference: 'Иаков 2:8',
          verse:
            'Если вы исполняете закон царский, по Писанию: «возлюби ближнего твоего, как себя самого», — хорошо делаете.',
          answer:
            'В девятой Он требует того, чтобы мы не лгали и не обманывали, но говорили правду с любовью. Десятая заповедь требует, чтобы мы никому не завидовали и не возмущались на Бога за то, что Он дал нам или кому-то.',
        },
        {
          id: 13,
          question: 'Может ли кто-нибудь исполнить все требования закона?',
          reference: 'Римлянам 3:10-12',
          verse:
            'как написано: «нет праведного ни одного; нет разумевающего; никто не ищет Бога; все совратились с пути, до одного негодны; нет делающего добро, нет ни одного».',
          answer:
            'После грехопадения ни один человек не может исполнить все требования закона так, как того требует Бог. Вместо этого люди постоянно нарушают его в мыслях, разговорах и поступках.',
        },
        {
          id: 14,
          question: 'Неужели Бог сотворил нас неспособными исполнять Его закон?',
          reference: 'Римлянам 5:12',
          verse:
            'Посему, как одним человеком грех вошел в мир, и грехом — смерть, так и смерть перешла во всех человеков, потому что в нем все согрешили.',
          answer:
            'Нет, но поскольку наши предки, Адам и Ева, не послушались Бога, все творение пало (это называется грехопадение). Все люди рождаются грешными и виновными, испорченными в своей сущности и неспособными исполнить требования Божьего закона.',
        },
        {
          id: 15,
          question: 'Но раз никто не может исполнить Божий закон, какой в нём смысл?',
          reference: 'Римлянам 3:20',
          verse:
            'потому что делами закона не оправдается пред Ним никакая плоть; ибо законом познаётся грех.',
          answer:
            'Чтобы мы могли знать святую природу и волю Бога, и грешную непокорную природу наших сердец. Следовательно, чтобы мы ощутили нужду в Спасителе. Закон также учит и побуждает нас правильно относиться друг к другу, жить достойно нашего Спасителя.',
        },
        {
          id: 16,
          question: 'Что такое грех?',
          reference: '1 Иоанна 3:4',
          verse:
            'Всякий, делающий грех, делает и беззаконие; и грех есть беззаконие.',
          answer:
            'Грех – это отвержение и игнорирование Бога в мире, который Он же сотворил. Это бунт против Бога, который проявляется в жизни без Бога и в неисполнении, нарушении требований Его закона. Результатом такой жизни является смерть и разрушение всего творения.',
        },
        {
          id: 17,
          question: 'Что такое идолопоклонство?',
          reference: 'Римлянам 1:21,25',
          verse:
            'Но как они, познав Бога, не прославили Его, как Бога, и не возблагодарили, но осуетились в умствованиях своих, и омрачилось несмысленное их сердце; Они заменили истину Божию ложью, и поклонялись, и служили твари вместо Творца, Который благословен вовеки, аминь.',
          answer:
            'Идолопоклонство – это надежда на сотворенные вещи более, чем на Творца. Надежда, что они принесут нам счастье, смысл и безопасность.',
        },
        {
          id: 18,
          question:
            'Оставит ли Бог наше непослушание и идолопоклонство ненаказанным?',
          reference: 'Ефесянам 5:5-6',
          verse:
            'ибо знайте, что никакой блудник, или нечистый, или любостяжатель, который есть идолослужитель, не имеет наследия в Царстве Христа и Бога. Никто да не обольщает вас пустыми словами, ибо за это приходит гнев Божий на сынов противления;',
          answer:
            'Нет, каждый грех – это восстание против всевластия, святости и доброты Бога, против Его справедливого закона, и Бог справедливо гневается на наши грехи и накажет их во время Своего справедливого суда как при жизни, так и после смерти.',
        },
        {
          id: 19,
          question:
            'Есть ли хоть малая возможность избежать наказания и вернуться в состояние, угодное Богу?',
          reference: 'Исаия 53:10-11',
          verse:
            'Но Господу угодно было поразить Его, и Он предал Его мучению; когда же душа Его принесет жертву умилостивления, Он узрит потомство долговечное, и воля Господня благоуспешно будет исполняться рукою Его. На подвиг души Своей Он будет смотреть с довольством; чрез познание Его Он, Праведник, Раб Мой, оправдает многих и грехи их на Себе понесет.',
          answer:
            'Да, чтобы удовлетворить Свое правосудие, Бог Сам, по своей бескорыстной милости, примиряет нас с Собой и уводит нас от греха и наказания за грех посредством Искупителя.',
        },
        {
          id: 20,
          question: 'Кто такой Искупитель?',
          reference: '1 Тимофею 2:5',
          verse:
            'Ибо един Бог, един и посредник между Богом и человеками, человек Христос Иисус,',
          answer:
            'Единый Искупитель – это Господь Иисус Христос, вечный Сын Божий, в Котором Бог стал человеком и Сам понес наказание за наши грехи.',
        },
      ],
    },

    // ──────────────────────────────────────────
    // PART 2 — Христос, искупление, благодать
    // ──────────────────────────────────────────
    {
      id: 2,
      title: 'Христос, искупление, благодать.',
      color: '#08537C', // deep blue
      icon: 'hands-prayer',
      questions: [
        {
          id: 21,
          question:
            'Какой Искупитель нужен, чтобы привести нас обратно к Богу?',
          reference: 'Исаия 9:6',
          verse:
            'Ибо младенец родился нам — Сын дан нам; владычество на раменах Его, и нарекут имя Ему: Чудный, Советник, Бог крепкий, Отец вечности, Князь мира.',
          answer: 'Только тот, кто одновременно и человек, и Бог.',
        },
        {
          id: 22,
          question: 'Почему Искупитель должен быть человеком?',
          reference: 'Евреям 2:17',
          verse:
            'Посему Он должен был во всем уподобиться братиям, чтобы быть милостивым и верным первосвященником пред Богом, для умилостивления за грехи народа.',
          answer:
            'Потому что в человеческом теле Он может ради нас совершенно покорится всему закону и быть замученным в наказание за наш грех. А также Он может сострадать нашим слабостям.',
        },
        {
          id: 23,
          question: 'Почему Искупитель должен быть Богом?',
          reference: 'Деяния 2:24',
          verse:
            'но Бог воскресил Его, расторгнув узы смерти, потому что ей невозможно было удержать Его.',
          answer:
            'Потому что только благодаря Его божественной природе, Его послушание и страдания будут совершенными и действственными. А также для того, чтобы вытерпеть праведный гнев Божий на грех и перенести смерть.',
        },
        {
          id: 24,
          question:
            'Почему было необходимо, чтобы Христос, Искупитель, умер?',
          reference: 'Колоссянам 1:21-22',
          verse:
            'И вас, бывших некогда отчужденными и врагами, по расположению к злым делам, ныне примирил в теле Плоти Его, смертью Его, чтобы представить вас святыми и непорочными и неповинными пред Собою,',
          answer:
            'Поскольку наказание за грех - смерть, Христос добровольно умер вместо нас чтобы избавить нас от власти и наказания греха и вернуть к Богу. Только Он своей заместительной и искупительной смертью освобождает нас от ада и дает нам прощение грехов, праведность и вечную жизнь.',
        },
        {
          id: 25,
          question:
            'Значит ли это, что, благодаря смерти Христа, все наши грехи могут быть прощены?',
          reference: '2 Коринфянам 5:21',
          verse:
            'Ибо не знавшего греха Он сделал для нас жертвою за грех, чтобы мы в Нем сделались праведными пред Богом.',
          answer:
            'Да, потому что смерть Христа на кресте полностью компенсировала наказание за наш грех. Бог по своей благодати вменяет нам праведность Христа так, словно это наша собственная праведность, и больше никогда не вспомнит наши грехи.',
        },
        {
          id: 26,
          question: 'Что еще искупает смерть Христа?',
          reference: 'Колоссянам 1:19-20',
          verse:
            'ибо благоугодно было Отцу, чтобы в Нем обитала всякая полнота, и чтобы посредством Его примирить с Собою все, умиротворив через Него, Кровию креста Его, и земное и небесное.',
          answer:
            'Смерть Христа – это начало искупления и обновления каждой части испорченного грехом творения, поскольку Бог руководит всем для собственной славы и пользы творения.',
        },
        {
          id: 27,
          question:
            'Если все люди оказались грешными через Адама, то все люди спасены через Христа?',
          reference: 'Римлянам 5:17',
          verse:
            'Ибо если преступлением одного смерть царствовала посредством одного, то тем более приемлющие обилие благодати и дар праведности будут царствовать в жизни посредством единого Иисуса Христа.',
          answer:
            'Жертвы Христа достаточно для спасения всех, но спасены те, которые соединены со Христом через личную веру в Него, как результат избрания и милости Божьей. Бог, по Своей милости, проявляет общую благодать ко всем, ограничивая действие греха и создавая условия для культурной деятельности и благосостояния.',
        },
        {
          id: 28,
          question:
            'Что происходит после смерти с теми, кто не соединен со Христом через веру?',
          reference: 'Иоанна 3:16-18, 36',
          verse:
            'Ибо так возлюбил Бог мир, что отдал Сына Своего Единородного, дабы всякий, верующий в Него, не погиб, но имел жизнь вечную. Ибо не послал Бог Сына Своего в мир, чтобы судить мир, но чтобы мир спасен был через Него. Верующий в Него не судится, а неверующий уже осужден, потому что не уверовал во имя Единородного Сына Божия. Верующий в Сына имеет жизнь вечную, а не верующий в Сына не увидит жизни, но гнев Божий пребывает на нем.',
          answer:
            'В день суда они получат страшный, но справедливый приговор осуждения, объявленный против них. Они будут изгнаны из удивительного Божьего присутствия в ад, чтобы нести вечное справедливое и мучительное наказание.',
        },
        {
          id: 29,
          question: 'Как мы можем спастись?',
          reference: 'Ефесянам 2:8-9',
          verse:
            'Ибо благодатью вы спасены через веру, и сие не от вас, Божий дар: не от дел, чтобы никто не хвалился.',
          answer:
            'Только через веру в Иисуса Христа и в Его заместительную искупительную смерть на кресте. Таким образом, хотя мы и виновны в непослушании Богу и все еще склонны ко всякому злу, Бог, без каких-либо наших заслуг перед Ним, но исключительно по Своей благодати, вменяет нам совершенную праведность Христа, когда мы каемся и верим в Него.',
        },
        {
          id: 30,
          question: 'Что такое вера в Иисуса Христа?',
          reference: 'Галатам 2:20',
          verse:
            'и уже не я живу, но живет во мне Христос. А что ныне живу во плоти, то живу верою в Сына Божия, возлюбившего меня и предавшего Себя за меня.',
          answer:
            'Вера в Иисуса Христа – это признание истинным всё, что Бог открыл в Своем Слове, доверие Ему, а также принятие Христа как единственный путь к спасению, предложенный Богом в Евангелии.',
        },
        {
          id: 31,
          question: 'Во что конкретно мы должны верить?',
          reference: 'Иуда 1:3',
          verse:
            'Возлюбленные! имея все усердие писать вам об общем спасении, я почел за нужное написать вам увещание — подвизаться за веру, однажды преданную святым.',
          answer:
            'Мы должны верить во всё, что написано в Писании. Апостольский Символ веры выражает это следующими словами: Мы верим в Бога, Отца всемогущего, Творца неба и земли. И в Иисуса Христа, Его единственного Сына, Господа нашего, который был зачат от Духа Святого, родился от Девы Марии, страдал при Понтии Пилате, был распят, умер и похоронен, сошел в ад, в третий день воскрес из мертвых, поднялся на небеса, сидит по правую руку от Бога Отца всемогущего, оттуда придёт судить живых и мертвых. Верим в Духа Святого, святую Вселенскую Церковь, общение святых, прощение грехов, воскресение тела, вечную жизнь.',
        },
        {
          id: 32,
          question: 'Что означает «оправдание» и «освящение»?',
          reference: '1 Петра 1:1-2',
          verse:
            'Петр, Апостол Иисуса Христа, пришельцам, рассеянным в Понте, Галатии, Каппадокии, Асии и Вифинии, избранным, по предведению Бога Отца, при освящении от Духа, к послушанию и окроплению Кровию Иисуса Христа: благодать вам и мир да умножится.',
          answer:
            'Оправдание означает нашу вмененную праведность перед Богом, возможную благодаря смерти Христа и Его воскресению ради нас. Освящение означает нашу постепенную, растущую праведность, возможную благодаря работе Духа Святого в нас.',
        },
        {
          id: 33,
          question:
            'Должны ли те, кто верит в Христа, пытаться спастись своими собственными делами или чем-то еще?',
          reference: 'Галатам 2:16',
          verse:
            'однако же, узнав, что человек оправдывается не делами закона, а только верою в Иисуса Христа, и мы уверовали во Христа Иисуса, чтобы оправдаться верою во Христа, а не делами закона; ибо делами закона не оправдается никакая плоть.',
          answer:
            'Нет, не должны, поскольку все необходимое для нашего спасение находится в Христе. Поиск спасения через добрые дела означает отрицание того, что Христос – это единственный Искупитель и Спаситель.',
        },
        {
          id: 34,
          question:
            'Поскольку мы искуплены только благодатью через веру в Христа, должны ли мы делать добрые дела и слушаться Божьего Слова?',
          reference: '1 Петра 2:9-12',
          verse:
            'Но вы — род избранный, царственное священство, народ святой, люди, взятые в удел, дабы возвещать совершенства Призвавшего вас из тьмы в чудный Свой свет; некогда не народ, а ныне народ Божий; некогда непомилованные, а ныне помилованные. Возлюбленные! прошу вас, как пришельцев и странников, удаляться от плотских похотей, восстающих на душу, и провождать добродетельную жизнь между язычниками, дабы они за то, за что злословят вас, как злодеев, увидя добрые дела ваши, прославили Бога в день посещения.',
          answer:
            'Да, потому что Христос, который искупил нас Своей кровью, также и обновляет нас Своим Духом. Теперь наши жизни могут проявлять любовь и благодарность Богу. Мы можем быть уверенны в вере, потому что в нашей жизни есть плоды. Итак, через наше угодное Богу поведение, другие люди могут узнать Христа.',
        },
        {
          id: 35,
          question:
            'Поскольку мы искуплены только благодатью и только через веру, откуда берется эта вера?',
          reference: 'Титу 3:4-6',
          verse:
            'Когда же явилась благодать и человеколюбие Спасителя нашего, Бога, Он спас нас не по делам праведности, которые бы мы сотворили, а по Своей милости, банею возрождения и обновления Святым Духом, Которого излил на нас обильно через Иисуса Христа, Спасителя нашего,',
          answer:
            'Христос Сам дает нам все дары через Святого Духа. В том числе и веру. Совершает Он это через наше чтение и слушание Слова Божьего.',
        },
      ],
    },

    // ──────────────────────────────────────────────────────────
    // PART 3 — Святой Дух, возрождение и возрастание в благодати
    // ──────────────────────────────────────────────────────────
    {
      id: 3,
      title: 'Святой Дух, возрождение и возрастание в благодати.',
      color: '#2D7D4F', // green
      icon: 'dove-spirit',
      questions: [
        {
          id: 36,
          question: 'Во что мы верим относительно Святого Духа?',
          reference: 'Иоанна 14:16-17',
          verse:
            'И Я умолю Отца, и даст вам другого Утешителя, да пребудет с вами вовек, Духа истины, Которого мир не может принять, потому что не видит Его и не знает Его; а вы знаете Его, ибо Он с вами пребывает и в вас будет.',
          answer:
            'Мы верим, что Он – Бог, вечный, как и Отец и Сын, и что Бог безвозвратно дарит Его всем верующим.',
        },
        {
          id: 37,
          question: 'Как Святой Дух помогает нам?',
          reference: 'Ефесянам 6:17-18',
          verse:
            'и шлем спасения возьмите, и меч духовный, который есть Слово Божие. Всякою молитвою и прошением молитесь во всякое время духом, и старайтесь о сем самом со всяким постоянством и молением о всех святых.',
          answer:
            'Святой Дух обличает нас в наших грехах, побуждает нас к покаянию, возрождает нас к новой жизни, утешает нас, направляет нас, дает нам духовные дары и желание слушаться Бога; также Он помогает нам молиться и понимать Божье Слово.',
        },
        {
          id: 38,
          question: 'Что такое молитва?',
          reference: 'Псалтирь 61:8-9',
          verse:
            'В Боге спасение мое и слава моя; крепость силы моей и упование мое в Боге. Народ! надейтесь на Него во всякое время; изливайте пред Ним сердце ваше: Бог нам прибежище.',
          answer:
            'Молитва – это открытие нашего сердца перед Богом в хвале, ходатайстве, прошении, исповедании греха и благодарении.',
        },
        {
          id: 39,
          question: 'С каким состоянием сердца нужно молиться?',
          reference: 'Филиппийцам 4:6',
          verse:
            'Не заботьтесь ни о чем, но всегда в молитве и прошении с благодарением открывайте свои желания пред Богом,',
          answer:
            'С любовью, настойчивостью и благодарностью; в смиренном подчинении Божьей воле, зная, что ради Христа Он всегда слышит наши молитвы.',
        },
        {
          id: 40,
          question: 'О чем мы должны молиться?',
          reference: 'Ефесянам 3:14-21',
          verse:
            'Для сего преклоняю колени мои пред Отцом Господа нашего Иисуса Христа, от Которого именуется всякое отечество на небесах и на земле, да даст вам, по богатству славы Своей, крепко утвердиться Духом Его во внутреннем человеке, верою вселиться Христу в сердца ваши, чтобы вы, укорененные и утвержденные в любви, могли постигнуть со всеми святыми, что широта и долгота, и глубина и высота, и уразуметь превосходящую разумение любовь Христову, дабы вам исполниться всею полнотою Божиею. А Тому, Кто действующею в нас силою может сделать несравненно больше всего, чего мы просим, или о чем помышляем, Тому слава в Церкви во Христе Иисусе во все роды, от века до века. Аминь.',
          answer:
            'Всё Божье Слово направляет нас и вдохновляет на правильную молитву, включая молитву, которой сам Иисус учил нас молиться.',
        },
        {
          id: 41,
          question: 'Что такое «Господня Молитва»?',
          reference: 'Матфея 6:9-13',
          verse:
            'Молитесь же так: «Отче наш, сущий на небесах! да святится имя Твое; да приидет Царствие Твое; да будет воля Твоя и на земле, как на небе; хлеб наш насущный дай нам на сей день; и прости нам долги наши, как и мы прощаем должникам нашим; и не введи нас в искушение, но избавь нас от лукавого. Ибо Твое есть Царство и сила и слава вовеки. Аминь».',
          answer:
            '«Молитесь же так: Отче наш, сущий на небесах! да святится имя Твое; да приидет Царствие Твое; да будет воля Твоя и на земле, как на небе; хлеб наш насущный дай нам на сей день; и прости нам долги наши, как и мы прощаем должникам нашим; не введи нас в искушение, но избавь нас от лукавого. Ибо Твое есть Царство и сила и слава во веки. Аминь»',
        },
        {
          id: 42,
          question: 'Как нужно читать и слушать Слово Божье?',
          reference: '2 Тимофею 3:16-17',
          verse:
            'Все Писание богодухновенно и полезно для научения, для обличения, для исправления, для наставления в праведности, да будет совершен Божий человек, ко всякому доброму делу приготовлен.',
          answer:
            'Ежедневно, с прилежанием, подготовкой и молитвой; только так мы можем принимать Слово с верой, хранить его в сердце и практиковать в жизни.',
        },
        {
          id: 43,
          question: 'Что такое «таинства»?',
          reference: 'Римлянам 6:4',
          verse:
            'Итак, мы погреблись с Ним крещением в смерть, дабы, как Христос воскрес из мертвых славою Отца, так и нам ходить в обновленной жизни.',
          answer:
            'Таинства даны Богом и установлены Христом, а именно: крещение и причастие (вечеря Господня). Это видимые знаки того, что мы объединены как община верующих в Иисуса через Его смерть и воскресение. Когда мы принимаем участие в этих таинствах, Святой Дух более глубоко показывает и подтверждает, что все обещания Евангелия исполняются в нас.',
        },
        {
          id: 44,
          question: 'Что такое «крещение»?',
          reference: 'Матфея 28:19',
          verse:
            'Итак, идите, научите все народы, крестя их во имя Отца и Сына и Святого Духа,',
          answer:
            'Крещение – погружение в воду во имя Отца, и Сына, и Святого Духа. Оно символизирует и подтверждает наше усыновление во Христе, наше очищение от греха, наше решение принадлежать Господу и Его церкви.',
        },
        {
          id: 45,
          question: 'Крещение в воде отчищает нас от греха?',
          reference: 'Луки 3:16',
          verse:
            'Иоанн всем отвечал: я крещу вас водою, но идёт Сильнейший меня, у Которого я недостоин развязать ремень обуви; Он будет крестить вас Духом Святым и огнем.',
          answer:
            'Нет, только кровь Христа и возрождение через Святого Духа может очистить нас от греха.',
        },
        {
          id: 46,
          question: 'Что такое «причастие»?',
          reference: '1 Коринфянам 11:23-26',
          verse:
            'Ибо я от Самого Господа принял то, что и вам передал, что Господь Иисус в ту ночь, в которую предан был, взял хлеб и, возблагодарив, преломил и сказал: «приимите, ядите, сие есть Тело Мое, за вас ломимое; сие творите в Мое воспоминание». Также и чашу после вечери, и сказал: «сия чаша есть новый завет в Моей Крови; сие творите, когда только будете пить, в Мое воспоминание». Ибо всякий раз, когда вы едите хлеб сей и пьете чашу сию, смерть Господню возвещаете, доколе Он придет.',
          answer:
            'Христос заповедал всем христианам есть хлеб и пить из чаши с благодарным воспоминанием о Нем и о Его смерти. Причастие – это торжественный символ того, что Бог присутствует среди нас; что Он соединил нас с Собой и друг с другом; что Он питает и поддерживает наши души. Причастие также провозглашает тот день, когда мы будем есть и пить вместе со Христом в царстве Его Отца.',
        },
        {
          id: 47,
          question:
            'Может ли причастие добавить что-то к искупительной смерти Христа?',
          reference: '1 Петра 3:18',
          verse:
            'потому что и Христос, чтобы привести нас к Богу, однажды пострадал за грехи наши, праведник за неправедных, быв умерщвлен по плоти, но ожив духом,',
          answer:
            'Нет, Христос умер однажды и за всех. Причастие – это пища завета, символизирующая искупительную работу Христа. Оно также может укрепить нашу веру, когда мы вспоминаем о Христе и предвкушаем будущий пир в царстве Бога. Но те, кто принимают в этом участие с неподготовленным сердцем, едят и пьют в свое собственное осуждение.',
        },
        {
          id: 48,
          question: 'Что такое церковь?',
          reference: '2 Фессалоникийцам 2:13',
          verse:
            'Мы же всегда должны благодарить Бога за вас, возлюбленные Господом братия, что Бог от начала, через освящение Духа и веру истине, избрал вас ко спасению,',
          answer:
            'Бог выбирает и сохраняет для Себя общину избранных для вечной жизни и объединенных верой в Иисуса Христа, которые любят и прославляют Бога, учатся у Него и следуют за Ним. Бог посылает эту общину в окружающий мир для того, чтобы она провозглашала Евангелие и служила прообразом царства Христа, показывая качеством своей жизни и любовью друг ко другу, на Бога, дающего силу так жить.',
        },
        {
          id: 49,
          question: 'Где сейчас находится Христос?',
          reference: 'Ефесянам 1:20-21',
          verse:
            'которою Он воздействовал во Христе, воскресив Его из мертвых и посадив одесную Себя на небесах, превыше всякого начальства, и власти, и силы, и господства, и всякого имени, именуемого не только в сем веке, но и в будущем,',
          answer:
            'На третий день после Своей смерти Христос воскрес, поднявшись из гроба, сорок дней являлся Своим ученикам, затем вознесся на небо и сел по правую руку от Отца. С тех пор, Христос царствует и ходатайствует за нас до того времени, пока Он не вернется для суда и обновления всего мира.',
        },
        {
          id: 50,
          question: 'В чем значение воскресения Христа для нас?',
          reference: '1 Фессалоникийцам 4:13-14',
          verse:
            'Не хочу же оставить вас, братия, в неведении об умерших, дабы вы не скорбели, как прочие, не имеющие надежды. Ибо, если мы веруем, что Иисус умер и воскрес, то и умерших в Иисусе Бог приведет с Ним.',
          answer:
            'Воскреснув из мертвых (физически), Христос победил грех и смерть, так что все, кто доверяет ему свою жизнь, так же воскресли для новой жизни в этом мире и для вечной жизни в будущем. В тот же день, когда мы воскреснем, восстановлен будет этот мир. Но те, кто не живет со Христом, воскреснут для вечной смерти.',
        },
        {
          id: 51,
          question: 'Какая польза в том, что Христос вознесся на небо?',
          reference: 'Римлянам 8:34',
          verse:
            'Кто осуждает? Христос Иисус умер, но и воскрес: Он и одесную Бога, Он и ходатайствует за нас.',
          answer:
            'Христос вознесся на небо физически ради нашей пользы, так же как ранее Он пришел на землю ради нас. Он заступается за нас перед Своим Отцом, приготовляя для нас место, а также послал Своего Духа.',
        },
        {
          id: 52,
          question: 'Почему нам важно помнить о вечной жизни?',
          reference: 'Откровение 21:1-4',
          verse:
            'И увидел я новое небо и новую землю, ибо прежнее небо и прежняя земля миновали, и моря уже нет. И я, Иоанн, увидел святой город Иерусалим, новый, сходящий от Бога с неба, приготовленный как невеста, украшенная для мужа своего. И услышал я громкий голос с неба, говорящий: се, скиния Бога с человеками, и Он будет обитать с ними; они будут Его народом, и Сам Бог с ними будет Богом их. И отрет Бог всякую слезу с очей их, и смерти не будет уже; ни плача, ни вопля, ни болезни уже не будет, ибо прежнее прошло.',
          answer:
            'Это напоминает нам о том, что настоящий падший мир – это еще не конец. Совсем скоро мы будем жить вечно вместе с Богом, будем наслаждаться Им в новом городе, в новых небесах и новой земле, где будет полная и вечная свобода от всякого греха. Мы будем жить там в обновленных, воскрешенных телах в новом, восстановленном творении.',
        },
      ],
    },
  ],

  // Original image URLs for reference
  images: {
    hero: 'https://usaregeneration.church/wp-content/uploads/2025/10/fon-k-ua-1920x760-1.jpg',
    part1Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k00b.jpeg',
    part2Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k000-1side.jpeg',
    part3Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k0000-1side.webp',
    cardBaseUrl:
      'https://usaregeneration.church/wp-content/uploads/2025/10/',
  },
};

export default catechismDataRu;
